// The gate in front of the farm.
//
// Sign-in is required, so this is what an unauthenticated visitor gets instead
// of the game. It deliberately does *not* redirect on its own: if the auth
// service turns a sign-in away, an automatic redirect would bounce the player
// straight back out again, and the loop is invisible from inside it. A button
// makes the failure legible and the retry deliberate.
import type { Account } from "./cloud.ts";

/** What went wrong last time, as `?auth=` leaves it on the URL. */
const REASONS: Record<string, string> = {
  access_denied: "Sign-in was cancelled.",
  bad_state: "That sign-in link had gone stale. Try again.",
  exchange_failed: "The auth service turned that sign-in down. Try again.",
  server_error: "Something broke on our side. Try again in a moment.",
};

export function showSignIn(stage: HTMLElement, account: Account): void {
  const reason = new URLSearchParams(location.search).get("auth");

  const screen = document.createElement("div");
  screen.className = "signin";
  screen.innerHTML = `
    <div class="signin-card">
      <h1>Farmstead</h1>
      <p class="signin-blurb">Till, plant, water, harvest, ship.</p>
      ${reason ? `<p class="signin-error">${REASONS[reason] ?? "Sign-in did not go through."}</p>` : ""}
      <a class="signin-go" href="${account.loginUrl ?? "/auth/login"}">Sign in with Mutaris</a>
      <p class="signin-foot">Your farm is saved to your account, so it follows you between devices.</p>
    </div>`;
  stage.appendChild(screen);

  // Drop the ?auth= marker so a refresh does not keep re-announcing an error
  // the player has already read.
  if (reason) history.replaceState(null, "", location.pathname);
}
